import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from './http-base.service';
import {
    UserCreateDto, UserDetailDto, UserListDto, UserPasswordUpdateDto, UserRoleUpdateDto,
    UserStateUpdateDto, UserUpdateDto
} from '../dtos/user.types';

@Injectable({
    providedIn: 'root'
})
export class UserService extends HttpBaseService {
    private readonly baseEndpoint = 'api/Users';

    /**
     * Get all users
     */
    getAllUsers(): Observable<UserListDto[]> {
        return this.get<UserListDto[]>(this.baseEndpoint);
    }

    /**
     * Get user by ID
     */
    getUserById(userId: string): Observable<UserDetailDto> {
        return this.get<UserDetailDto>(`${this.baseEndpoint}/${userId}`);
    }

    /**
     * Get user for update
     */
    getUserForUpdate(userId: string): Observable<UserUpdateDto> {
        return this.get<UserUpdateDto>(`${this.baseEndpoint}/${userId}/update`);
    }

    /**
     * Create a new user
     * @returns Observable containing the created user's ID
     */
    createUser(user: UserCreateDto): Observable<{ id: string }> {
        return this.post<{ id: string }>(this.baseEndpoint, user);
    }

    /**
     * Update an existing user
     */
    updateUser(user: UserUpdateDto): Observable<void> {
        return this.put<void>(this.baseEndpoint, user);
    }

    /**
     * Update user password
     */
    updatePassword(passwordUpdate: UserPasswordUpdateDto): Observable<void> {
        return this.patch<void>(`${this.baseEndpoint}/password-update`, passwordUpdate);
    }

    /**
     * Reset user password
     */
    resetPassword(userId: string): Observable<void> {
        return this.patch<void>(`${this.baseEndpoint}/password/${userId}/reset`);
    }

    /**
     * Update user role
     */
    updateUserRole(roleUpdate: UserRoleUpdateDto): Observable<void> {
        return this.patch<void>(`${this.baseEndpoint}/role-update`, roleUpdate);
    }

    /**
     * Update user state (active/inactive)
     */
    updateUserState(stateUpdate: UserStateUpdateDto): Observable<void> {
        return this.patch<void>(`${this.baseEndpoint}/state-update`, stateUpdate);
    }
}